<template>
    <div class="pt-3 px-4" v-if="refresh">
        <InputCreditCard
                v-model:inputValue="creditCardModel.cardNumber"
                :errorInfo="errorInfo[0]"
                :isShowError="false"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.creditCard.add.cardNumber"
        ></InputCreditCard>
        <InputText
                v-model:inputValue="creditCardModel.cardName"
                :errorInfo="errorInfo[1]"
                :isShowError="false"
                :isSubmitted="isSubmitted"
                :maxLength="50"
                :inputLbl="lbl.creditCard.add.cardName"
        ></InputText>
        <div class="grid grid-cols-2 gap-2">
            <InputExpireDate
                    v-model:inputValue="creditCardModel.expireDate"
                    :errorInfo="errorInfo[2]"
                    :isShowError="false"
                    :isSubmitted="isSubmitted"
                    
                    :inputLbl="lbl.creditCard.add.expireDate"
            ></InputExpireDate>
            <InputCVV
                    v-model:inputValue="creditCardModel.securityCode"
                    :errorInfo="errorInfo[3]"
                    :isShowError="false"
                    :isSubmitted="isSubmitted"
                    :maxLength="3"
                    :inputLbl="lbl.creditCard.add.securityCode"
            ></InputCVV>
        </div>
        <Checkbox v-if="!isGuestAccountRegistered"
                v-model:check="creditCardModel.isDefault"
                :text="lbl.creditCard.add.isDefault"
        ></Checkbox>
        <div class="text-12 text-a-brown-9f8273">{{lbl.creditCard.info}}</div>
    </div>
</template>
<script>
// import Util from "@/helper/Utility.js";
import { FormHelper } from "@/helper/FormHelper.js";
//component
import InputText from "@/components/Input/label/InputText.vue";
import InputCreditCard from "@/components/Input/label/InputCreditCard.vue";
import InputExpireDate from "@/components/Input/label/InputExpireDate.vue";
import Checkbox from "@/components/Input/simple/Checkbox.vue";
import InputCVV from "@/components/Input/label/InputCVV.vue";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from '@/mixin/ModalMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin';
//service
import { CreditCardModel } from "../model/CreditCardModel.js";

export default {
    name: "FormCreditCard",
    mixins: [LocaleMixin,ModalMixin,AuthStatusMixin],
    components: {
        InputText,
        Checkbox,
        InputCreditCard,
        InputExpireDate,
        InputCVV
        //FormAddressDropdown,
    },
    data: function() {
        return {
            isSubmitted: false,
            errorInfo: [],
            refresh: true,

            formAddressModel: null,
            creditCardModel: null,
        };
    },
    created: function() {

        this.initForm(null);
        this.errorInfo = FormHelper.genErrorInfo(4);
    },
    methods: {
        initForm: function(creditCard) {
            this.isSubmitted = false;

            if (creditCard != null) {
                this.creditCardModel = {...creditCard};
            } else {
                this.creditCardModel = new CreditCardModel();
            }

            this.refresh = false;
            this.$nextTick(() => {
                this.refresh = true;
            });
        },
        clearForm: function() {
            this.initForm(null);
        },
        submitForm: function() {
            this.isSubmitted = true;
            if (this.validate()) {
                //this.addressModel.setValueFromAddressModel(this.formAddressModel);
                return this.creditCardModel;
            } else {
                this.modal.errorModal.clearModal()
                                    .setMsg(FormHelper.getFirstErrorItem(this.errorInfo).msg)
                                    .show();
            }
            return null
        },
        validate: function() {
            return FormHelper.validate(this.errorInfo);
        },
    },
}
</script>
